import {ID, Resource} from 'simpli-web-sdk'
import DeliveryReceiverResponseSchema from '@/schema/DeliveryReceiverResponse.schema'

export default class DeliveryReceiverResponse extends Resource {

  readonly $name: string = 'DeliveryReceiverResponse'
  readonly $endpoint: string = '/user/indicador/entrega-por-destinatario'

  get $id() {
    return this.id
  }
  set $id(val: ID) {
    this.id = val
  }

  get $schema() {
    return DeliveryReceiverResponseSchema(this)
  }

  id: ID = 0
  nome: string | null = null
  qtdTotal: number | null = null
  qtdSemOcorrencia: number | null  = null
  qtdComOcorrencia: number | null  = null
  qtdDevolvidas: number | null  = null
  documento: string | null = null

}
